

export const summaries = {

    "next_steps": {
        "title": "Interview questions suggested",
        "model": "gpt-4o",
    },
    "project_description": {
        "title": "Context",
        "model": "gpt-4o",
    },
    "baseline": {
        "title": "Baseline Summary",
        "model": "gpt-4o",
    },

    "advance": {
        "title": "Advance Summary",
        "model": "gpt-4o",
    },
    "uncertainty": {
        "title": "Uncertainty Summary",
        "model": "gpt-4o",
    },
    "resolution": {
        "title": "Resolution Summary",
        "model": "gpt-4o",
    }
};


export const evaluations = {
    "qualifying_field_evaluation": {
        "title": "Qualifying Field",
        "model": "gpt-4o",
    },
    "project_description_comprehensiveness": {
        "title": "Context",
        "model": "gpt-4o",
    },
    "baseline_comprehensiveness": {
        "title": "Baseline",
        "model": "gpt-4o",
    },
    "advance_comprehensiveness": {
        "title": "Advance",
        "model": "gpt-4o",
    },
    "uncertainty_comprehensiveness": {
        "title": "Uncertainty",
        "model": "gpt-4o",
    },
    "resolution_comprehensiveness": {
        "title": "Resolution",
        "model": "gpt-4o",
    },
    "advance_check": {
        "title": "Appreciable Improvement",
        "model": "gpt-4o",
    },
    "uncertainty_check_publicly_available": {
        "title": "Uncertainty - Not Publicly Available",
        "model": "gpt-4o",
    },
    "uncertainty_check_readily_deducible": {
        "title": "Uncertainty - Not Readily Deducible",
        "model": "gpt-4o",
    },
    "resolution_check": {
        "title": "Qualifying Activities Directly Contributing to Resolving Uncertainty",
        "model": "gpt-4o",
    },
  
}
